import { parseApiErrorMessage } from "../request/case-tabs/financialCoreUtils";

export { parseApiErrorMessage };

export const pick = (obj, camel, pascal) =>
  obj?.[camel] ?? obj?.[pascal] ?? null;

export const formatRial = (value) => {
  if (value == null || value === "") return "—";
  const n = Number(value);
  if (Number.isNaN(n)) return "—";
  return `${n.toLocaleString("fa-IR")} ریال`;
};

export const GATEWAY_SESSION = {
  PendingGateway: "PendingGateway",
  Redirected: "Redirected",
  CallbackReceived: "CallbackReceived",
  Verified: "Verified",
  Settled: "Settled",
  Succeeded: "Succeeded",
  Failed: "Failed",
  Reversed: "Reversed",
  Unknown: "Unknown",
};

export const TX_STATUS = {
  Pending: "Pending",
  Succeeded: "Succeeded",
  Failed: "Failed",
};

export const getProviderLabel = (provider) => {
  const p = String(provider ?? "").toLowerCase();
  if (p === "mellat" || p === "1") return "بانک ملت";
  return provider || "درگاه بانک";
};

export const normalizePaymentStatus = (res) => {
  if (!res || res.isSuccess === false) {
    return { error: parseApiErrorMessage(res, "بارگذاری وضعیت پرداخت ناموفق بود."), data: null };
  }
  const d = res.data ?? res.Data ?? res;
  return { error: null, data: d };
};

export const normalizeStartPayment = (res) => {
  if (!res || res.isSuccess === false) {
    return { error: parseApiErrorMessage(res, "شروع پرداخت ناموفق بود."), data: null };
  }
  return { error: null, data: res.data ?? res.Data ?? res };
};

export const normalizePaymentResult = (res) => {
  if (!res || res.isSuccess === false) {
    return { error: parseApiErrorMessage(res, "دریافت نتیجه پرداخت ناموفق بود."), data: null };
  }
  return { error: null, data: res.data ?? res.Data ?? res };
};

export const normalizeUnpaidSummary = (res) => {
  if (!res || res.isSuccess === false) {
    return {
      error: parseApiErrorMessage(res, "بارگذاری خلاصه پرداخت ناموفق بود."),
      data: null,
    };
  }
  return { error: null, data: res.data ?? res.Data ?? res };
};

/** Unified badge states for customer payment UI */
export const PAYMENT_BADGE_STATE = {
  Pending: "Pending",
  Redirected: "Redirected",
  Succeeded: "Succeeded",
  Failed: "Failed",
  Unknown: "Unknown",
};

const SESSION_TO_BADGE = {
  PendingGateway: PAYMENT_BADGE_STATE.Pending,
  Redirected: PAYMENT_BADGE_STATE.Redirected,
  CallbackReceived: PAYMENT_BADGE_STATE.Pending,
  Verified: PAYMENT_BADGE_STATE.Pending,
  Settled: PAYMENT_BADGE_STATE.Pending,
  Succeeded: PAYMENT_BADGE_STATE.Succeeded,
  Failed: PAYMENT_BADGE_STATE.Failed,
  Reversed: PAYMENT_BADGE_STATE.Failed,
  Unknown: PAYMENT_BADGE_STATE.Unknown,
};

export const mapSessionToBadgeState = (sessionStatus) => {
  if (sessionStatus == null || sessionStatus === "") {
    return PAYMENT_BADGE_STATE.Unknown;
  }
  const key = String(sessionStatus);
  return SESSION_TO_BADGE[key] ?? PAYMENT_BADGE_STATE.Unknown;
};

export const mapUiStateToBadgeState = (uiState) => {
  switch (uiState) {
    case "succeeded":
      return PAYMENT_BADGE_STATE.Succeeded;
    case "failed":
      return PAYMENT_BADGE_STATE.Failed;
    case "redirected":
      return PAYMENT_BADGE_STATE.Redirected;
    case "pending":
      return PAYMENT_BADGE_STATE.Pending;
    case "unpaid":
      return PAYMENT_BADGE_STATE.Pending;
    default:
      return PAYMENT_BADGE_STATE.Unknown;
  }
};

export const getPaymentBadgeLabel = (state) => {
  switch (state) {
    case PAYMENT_BADGE_STATE.Succeeded:
      return "پرداخت شده";
    case PAYMENT_BADGE_STATE.Failed:
      return "امکان تلاش مجدد وجود دارد";
    case PAYMENT_BADGE_STATE.Redirected:
      return "در انتظار تکمیل پرداخت";
    case PAYMENT_BADGE_STATE.Pending:
      return "در حال بررسی پرداخت";
    case PAYMENT_BADGE_STATE.Unknown:
    default:
      return "در حال بررسی پرداخت";
  }
};

export const normalizeRequestsPaymentSummary = (res) => {
  if (!res || res.isSuccess === false) {
    return {
      error: parseApiErrorMessage(res, "بارگذاری وضعیت پرداخت درخواست‌ها ناموفق بود."),
      data: [],
    };
  }
  const d = res.data ?? res.Data ?? [];
  return { error: null, data: Array.isArray(d) ? d : [] };
};

export const normalizeRequestInvoicesPanel = (res) => {
  if (!res || res.isSuccess === false) {
    return {
      error: parseApiErrorMessage(res, "بارگذاری فاکتورهای پرونده ناموفق بود."),
      data: null,
    };
  }
  return { error: null, data: res.data ?? res.Data ?? res };
};

/** Operational states from API (SlnOperationalPaymentState) */
export const mapOperationalStateToBadge = (operationalState) => {
  const key = String(operationalState ?? "");
  switch (key) {
    case "Paid":
      return PAYMENT_BADGE_STATE.Succeeded;
    case "FailedRetry":
      return PAYMENT_BADGE_STATE.Failed;
    case "AwaitingPayment":
      return PAYMENT_BADGE_STATE.Redirected;
    case "PendingReview":
    case "PartiallyPaid":
      return PAYMENT_BADGE_STATE.Pending;
    case "Payable":
      return PAYMENT_BADGE_STATE.Pending;
    default:
      return PAYMENT_BADGE_STATE.Unknown;
  }
};

export const getPaymentBadgeColor = (state) => {
  switch (state) {
    case PAYMENT_BADGE_STATE.Succeeded:
      return "success";
    case PAYMENT_BADGE_STATE.Failed:
      return "error";
    case PAYMENT_BADGE_STATE.Redirected:
    case PAYMENT_BADGE_STATE.Pending:
      return "warning";
    case PAYMENT_BADGE_STATE.Unknown:
    default:
      return "warning";
  }
};
